import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-down",
  "use": "arrow-down-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol viewBox=\"0 0 512 512\" id=\"arrow-down\"><path d=\"M255 280l169-174c16-18 43-18 60 0l15 15c17 18 17 46 0 64L302 390c-1 0-1 0-1 1l-15 15c-9 9-20 14-31 14s-22-5-30-14l-15-15-1-1L13 185c-17-18-17-46 0-64l15-15c16-18 44-18 60 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/arrow-down.svg
// module id = 176
// module chunks = 0